export function formatCurrency(num): string {
	let number = num.toString();

	const isMinusNumber = number.startsWith("-");

	number = number.replace(/\D/g, "");

	const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	return isMinusNumber ? `-${formattedNumber}` : formattedNumber;
}

export function setPositionDuringFormatting(num, target, position): void {
	const preLength = target.value.length;
	target.value = formatCurrency(target.value);
	const postLength = target.value.length;

	if (preLength < postLength) {
		position += 1;
	}

	if (postLength < preLength && position > 0) {
		position -= 1;
	}

	target.setSelectionRange(position, position);
}
